import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Resource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeSubordinates(
    request: Boundaries["removeSubordinates"]["request"],
  ): void;
}

function useRemoveSubordinates(manager: Identifiable<Resource>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveSubordinatesRequestPending(manager),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveSubordinatesRequestSuccess(manager),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveSubordinatesRequestFailure(manager),
    ),
    removeSubordinates: core.removeSubordinates,
  };
}

export { useRemoveSubordinates };
